import React, { HTMLAttributes, ReactNode } from 'react';
import c from 'classnames';

import { Button, Icon, isExternalLink } from '@uncinc/uncinc-react-kitchen-sink';

interface ButtonWrapperProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  children?: ReactNode;
  onClick?: () => void;
  secondary?: boolean;
  textual?: boolean;
  href?: string;
  className?: string;
  iconName?: string;
}

const ButtonWrapper: React.FC<ButtonWrapperProps> = ({
  children,
  onClick,
  secondary = false,
  textual = false,
  href = '',
  className = '',
  iconName = '',
  ...props
}) => {
  let icon = iconName;

  const buttonClasses = c(className, {
    'Button--primary': !secondary && !textual,
    'Button--secondary': secondary,
    'Button--textual': textual,
  });

  if (href && !iconName) {
    icon = !isExternalLink(href) ? 'arrow_forward' : 'north_east';
  }

  return (
    <Button
      className={buttonClasses}
      onClick={onClick}
      primary={false}
      href={href}
      componentIsWrapped
      {...props}
    >
      <div className="Button__inner">
        {children}
        {(href || secondary || icon) && (
          <Icon name={`${icon}`} flair="outlined" />
        )}
      </div>
    </Button>
  );
};


export default ButtonWrapper;
